import { translateInline } from './inlineTranslations';

const NAKSHATRAS = [
  'Ashwini', 'Bharani', 'Krittika', 'Rohini', 'Mrigashira', 'Ardra', 'Punarvasu',
  'Pushya', 'Ashlesha', 'Magha', 'Purva Phalguni', 'Uttara Phalguni', 'Hasta',
  'Chitra', 'Swati', 'Vishakha', 'Anuradha', 'Jyeshtha', 'Mula', 'Purva Ashadha',
  'Uttara Ashadha', 'Shravana', 'Dhanishta', 'Shatabhisha', 'Purva Bhadrapada',
  'Uttara Bhadrapada', 'Revati',
] as const;

const HINDI_NAKSHATRAS = [
  'अश्विनी', 'भरणी', 'कृत्तिका', 'रोहिणी', 'मृगशिरा', 'आर्द्रा', 'पुनर्वसु',
  'पुष्य', 'आश्लेषा', 'मघा', 'पूर्व फाल्गुनी', 'उत्तर फाल्गुनी', 'हस्त',
  'चित्रा', 'स्वाती', 'विशाखा', 'अनुराधा', 'ज्येष्ठा', 'मूल', 'पूर्वाषाढ़ा',
  'उत्तराषाढ़ा', 'श्रवण', 'धनिष्ठा', 'शतभिषा', 'पूर्व भाद्रपदा',
  'उत्तर भाद्रपदा', 'रेवती',
] as const;

const LORDS = ['KETU', 'VENUS', 'SUN', 'MOON', 'MARS', 'RAHU', 'JUPITER', 'SATURN', 'MERCURY'] as const;
const normalize = (value: string) => value.toLowerCase().replace(/[^a-z]/g, '').replace('dhanishtha', 'dhanishta').replace('moola', 'mula');

export const vedicNakshatraIndex = (value: any): number => {
  const name = typeof value?.nakshatra === 'string' ? value.nakshatra : value?.nakshatra?.name;
  if (typeof name === 'string') {
    const index = NAKSHATRAS.findIndex((item) => normalize(item) === normalize(name));
    if (index >= 0) return index;
  }
  const longitude = value?.longitude == null ? NaN : Number(value.longitude);
  return Number.isFinite(longitude) ? Math.floor(((((longitude % 360) + 360) % 360) + 1e-9) / (360 / 27)) % 27 : -1;
};

export const vedicNakshatraName = (value: any, language: string): string => {
  const index = vedicNakshatraIndex(value);
  const original = typeof value?.nakshatra === 'string' ? value.nakshatra : value?.nakshatra?.name;
  if (index < 0) return original || '—';
  if (language.startsWith('hi')) return HINDI_NAKSHATRAS[index];
  const canonical = NAKSHATRAS[index];
  const translated = translateInline(language, canonical);
  return translated === canonical ? translateInline(language, original || canonical) : translated;
};

export const vedicNakshatraLord = (value: any): string => {
  const direct = value?.nakshatra?.lord || value?.nakshatra?.ruler || value?.starLord;
  if (typeof direct === 'string' && direct.trim()) return direct.trim().toUpperCase();
  const index = vedicNakshatraIndex(value);
  return index < 0 ? '' : LORDS[index % LORDS.length];
};

const HINDI_UPAGRAHAS: Record<string, string> = {
  Mandi: 'मांदी', Gulika: 'गु', Dhuma: 'धू', Vyatipata: 'व्य',
  Parivesha: 'परि', Indrachapa: 'इं', Upaketu: 'उप',
};

export const vedicUpagrahaLabel = (key: string, shortName: string | undefined, language: string): string => {
  if (language.startsWith('hi')) return HINDI_UPAGRAHAS[key] || shortName || key;
  const translated = translateInline(language, key);
  return translated === key ? shortName || key : translated;
};
